import {Vue} from 'ui.vue';

import Const from './Const';

import 'bxmaker.authuserphone.core';
import './components/BXmakerAuthuserphoneSimple.js';


export class Simple {
    constructor(rootId, data) {
        this.rootId = rootId;
        this.data = data;
        this.rand = data.rand;
        this.instance = null;

        this.initTemplate();
    }


    initTemplate() {
        const context = this;

        this.instance = Vue.createApp({
            name: 'BXmakerAuthuserphoneSimpleContainer_' + this.rand,
            key: this.rand,
            data() {
                return {
                    data: context.data,

                    isEnabledReload: true,
                    isEnabledRedirect: true,

                    isAuthorized: context.data.isAuthorized,

                    isEnabledPhoneMask: context.data.isEnabledPhoneMask,
                    phoneMaskDefaultCountry: context.data.phoneMaskDefaultCountry,
                    phoneMaskCountryTopList: context.data.phoneMaskCountryTopList,

                    confirmationType: Const.CONFIRM_TYPE_SMS_CODE,

                    isShowConfirm: false, // показывать блок с проверкой

                    authByPhoneLoader: false, // выполняется попытка авторизации

                    captchaId: false,
                    captchaCode: false,
                    captchaSrc: false,
                    captchaLength: false,
                    captchaLoader: false,

                    phone: '', // введенный телефон
                    formattedPhone: '', // форматированный номер телефона

                    phoneError: '', // ошибка при проверкке номера телефона

                    currentPhone: '', //текущий номер телефона, выводится при смене
                    currentFormattedPhone: '', // текущий форматированный номер телефона, выводится при смене

                    email: '', // введенный email
                    password: '', // введенный пароль

                    message: false, // сообщение
                    error: false, // сообщение об ошибкой


                    expandData: {},

                    // sms
                    smsCodeLength: 4,
                    smsCodeTimeout: 0,
                    smsCode: '',
                    smsCodeError: '',
                    smsCodeStartLoader: false,
                    smsCodeCheckLoader: false,

                    //проверка через звонок от пользователя
                    userCallTo: '',
                    userCallStartLoader: false,
                    userCallCheckLoader: false,
                    userCallTimeout: 0,

                    // звонок от робота
                    botCallCode: '',
                    botCallLength: 4,
                    botCallTimeout: 0,
                    botCallStartLoader: false,
                    botCallCheckLoader: false,

                    // голосовой код
                    botSpeechCode: '',
                    botSpeechLength: 4,
                    botSpeechTimeout: 0,
                    botSpeechStartLoader: false,
                    botSpeechCheckLoader: false,

                };
            },
            created() {
                if (this.confirmationList.length > 0 && this.confirmationList[0] !== this.confirmationType) {
                    this.setConfirmType(this.confirmationList[0]);
                }
            },
            computed: {
                localize() {
                    return BX.Vue.getFilteredPhrases('BXMAKER_AUTHUSERPHONE_SIMPLE_');
                },
                const() {
                    return Const;
                },
                // базовый массив парамтров для запроса по ajax
                baseAjaxData() {
                    let confirmType = '';
                    let confirmValue = '';
                    if (this.isConfirmBySmsCode) {
                        confirmType = this.const.CONFIRM_TYPE_SMS_CODE;
                        confirmValue = this.smsCode;
                    } else if (this.isConfirmByUserCall) {
                        confirmType = this.const.CONFIRM_TYPE_USER_CALL;
                        confirmValue = this.userCallTo;
                    } else if (this.isConfirmByBotCall) {
                        confirmType = this.const.CONFIRM_TYPE_BOT_CALL;
                        confirmValue = this.botCallCode;
                    } else if (this.isConfirmByBotSpeech) {
                        confirmType = this.const.CONFIRM_TYPE_BOT_SPEECH;
                        confirmValue = this.botSpeechCode;
                    }

                    return {
                        sessid: BX.bitrix_sessid(),
                        siteId: this.data.siteId,
                        template: this.data.template,
                        parameters: this.data.parameters,
                        rand: this.data.rand,

                        expandData: {...this.expandData},
                        confirmType: confirmType,
                        confirmValue: confirmValue,
                        captchaId: this.captchaId,
                        captchaCode: this.captchaCode,
                    }
                },

                /**
                 * Вернет массив вараинтов подтверждения номера телефона
                 * в нужном нам порядке
                 * @returns {string[]}
                 */
                confirmationList() {
                    let list = this.data.confirmQueue;

                    if (!this.data.isEnabledConfirmBySmsCode) {
                        list = list.filter(row => row !== this.const.CONFIRM_TYPE_SMS_CODE);
                    }
                    if (!this.data.isEnabledConfirmByUserCall) {
                        list = list.filter(row => row !== this.const.CONFIRM_TYPE_USER_CALL);
                    }
                    if (!this.data.isEnabledConfirmByBotCall) {
                        list = list.filter(row => row !== this.const.CONFIRM_TYPE_BOT_CALL);
                    }
                    if (!this.data.isEnabledConfirmByBotSpeech) {
                        list = list.filter(row => row !== this.const.CONFIRM_TYPE_BOT_SPEECH);
                    }

                    if (list.length <= 0) {
                        list.push(this.const.CONFIRM_TYPE_SMS_CODE);
                    }
                    return list;
                },

                isConfirmBySmsCode() {
                    return this.confirmationType === this.const.CONFIRM_TYPE_SMS_CODE;
                },
                isConfirmByUserCall() {
                    return this.confirmationType === this.const.CONFIRM_TYPE_USER_CALL;
                },
                isConfirmByBotCall() {
                    return this.confirmationType === this.const.CONFIRM_TYPE_BOT_CALL;
                },
                isConfirmByBotSpeech() {
                    return this.confirmationType === this.const.CONFIRM_TYPE_BOT_SPEECH;
                },

                startLoader() {
                    return this.smsCodeStartLoader || this.userCallStartLoader || this.botCallStartLoader || this.botSpeechStartLoader;
                },

                checkLoader() {
                    return this.smsCodeCheckLoader || this.userCallCheckLoader || this.botCallCheckLoader || this.botSpeechCheckLoader;
                },

                isNeedShowConfirmSmsCode() {
                    return !this.isAuthorized
                        && this.isShowConfirm
                        && this.confirmationType === this.const.CONFIRM_TYPE_SMS_CODE;
                },
                isNeedShowConfirmUserCall() {
                    return !this.isAuthorized
                        && this.isShowConfirm
                        && this.confirmationType === this.const.CONFIRM_TYPE_USER_CALL;
                },
                isNeedShowConfirmBotCall() {
                    return !this.isAuthorized
                        && this.isShowConfirm
                        && this.confirmationType === this.const.CONFIRM_TYPE_BOT_CALL;
                },
                isNeedShowConfirmBotSpeech() {
                    return !this.isAuthorized
                        && this.isShowConfirm
                        && this.confirmationType === this.const.CONFIRM_TYPE_BOT_SPEECH;
                },
                isNeedShowChangeConfirm() {
                    return !this.isAuthorized
                        && this.isShowConfirm
                        && this.confirmationList.length > 1;
                },
                isFullCaptcha() {
                    if (!this.captchaId) {
                        return true;
                    }

                    if (this.captchaLength === this.captchaCode.toString().length) {
                        return true;
                    }

                    return false;
                }
            },
            methods: {
                resetExpandData() {
                    this.expandData = {};
                },
                setExpandData(name, value) {
                    this.expandData[name] = value;
                },

                // вклчюение/отключение перезагурзки страницы после авторизации
                setIsEnabledReload(flag) {
                    this.isEnabledReload = !!flag;
                },

                // включаение/отключение редиректа после авторизации
                setIsEnabledRedirect(flag) {
                    this.isEnabledRedirect = !!flag;
                },


                setPhone(value) {
                    this.phone = value;
                },
                setPhoneError(value) {
                    this.phoneError = value;
                },
                setFormattedPhone(value) {
                    this.formattedPhone = value;
                },

                setIsAuthorized(value) {
                    this.isAuthorized = !!value;
                },

                setAuthByPhoneLoader(value) {
                    this.authByPhoneLoader = !!value;

                    this.smsCodeCheckLoader = !!value;
                    this.userCallCheckLoader = !!value;
                    this.botCallCheckLoader = !!value;
                    this.botSpeechCheckLoader = !!value;
                },


                // sms -------------------------
                setSmsCodeLength(value) {
                    this.smsCodeLength = value;
                },
                setSmsCodeTimeout(value) {
                    this.smsCodeTimeout = value;
                },
                setSmsCode(value) {
                    this.smsCode = value;
                },
                setSmsCodeError(value) {
                    this.smsCodeError = value;
                },
                setSmsCodeStartLoader(value) {
                    this.smsCodeStartLoader = value;
                },
                setSmsCodeCheckLoader(value) {
                    this.smsCodeCheckLoader = value;
                },


                //проверка через звонок от пользователя
                setUserCallTo(value) {
                    this.userCallTo = value;
                },
                setUserCallStartLoader(value) {
                    this.userCallStartLoader = value;
                },
                setUserCallCheckLoader(value) {
                    this.userCallCheckLoader = value;
                },
                setUserCallTimeout(value) {
                    this.userCallTimeout = value;
                },


                // звонок от робота
                setBotCallCode(value) {
                    this.botCallCode = value;
                },
                setBotCallLength(value) {
                    this.botCallLength = value;
                },
                setBotCallTimeout(value) {
                    this.botCallTimeout = value;
                },
                setBotCallStartLoader(value) {
                    this.botCallStartLoader = value;
                },
                setBotCallCheckLoader(value) {
                    this.botCallCheckLoader = value;
                },

                // голосовой код
                setBotSpeechCode(value) {
                    this.botSpeechCode = value;
                },
                setBotSpeechLength(value) {
                    this.botSpeechLength = value;
                },
                setBotSpeechTimeout(value) {
                    this.botSpeechTimeout = value;
                },
                setBotSpeechStartLoader(value) {
                    this.botSpeechStartLoader = value;
                },
                setBotSpeechCheckLoader(value) {
                    this.botSpeechCheckLoader = value;
                },


                // при клике на кнпоку  другйо вариант подтверждения
                changeConfirmType() {
                    let list = this.confirmationList;
                    let current = this.confirmationType;

                    if (list.length > 1) {
                        let newconfirmationType = list[0];
                        let index = list.indexOf(current);
                        if (index > -1 && !!list[index + 1]) {
                            newconfirmationType = list[index + 1];
                        }
                        if (newconfirmationType !== current) {
                            this.setConfirmType(newconfirmationType);
                            this.startConfirm();
                        }
                    }
                },

                // установка текущего варианта подтверждения
                setConfirmType(type) {
                    let list = this.confirmationList;
                    if (~list.indexOf(type)) {
                        this.resetMessage();
                        this.confirmationType = type;
                    }
                },

                //Показать блок подтверждения
                showConfirm() {
                    this.isShowConfirm = true;
                },
                // скрыть блок подтверждения
                hideConfirm() {
                    this.isShowConfirm = false;
                },

                // сброс мообщений об ошибках или успехах
                resetMessage() {
                    this.phoneError = false;
                    this.message = false;
                    this.error = false;
                },

                //запись ошибки
                setError(msg) {
                    this.message = msg;
                    this.error = true;
                },


                // разбор ошибок
                parseError(error) {

                    if (error.more && error.more.formattedPhone) {
                        this.setFormattedPhone(error.more.formattedPhone);
                    }


                    switch (error.code) {
                        case 'ERROR_NEED_CONFIRM': {
                            this.resetCaptcha();
                            this.startConfirm();
                            this.showConfirm();
                            break;
                        }
                        case 'ERROR_INVALID_PHONE': {
                            this.resetCaptcha();
                            this.hideConfirm();
                            this.setPhoneError(error.msg);
                            break;
                        }
                        case 'ERROR_NEED_WAIT_TIMEOUT': {
                            this.resetCaptcha();
                            this.showConfirm();


                            if (this.confirmationType === this.const.CONFIRM_TYPE_SMS_CODE) {
                                this.setSmsCodeTimeout(error.more.timeout);
                                this.setSmsCodeLength(error.more.length);

                            } else if (this.confirmationType === this.const.CONFIRM_TYPE_USER_CALL) {
                                this.setUserCallTimeout(error.more.timeout);
                                if (error.more.callTo) {
                                    this.setUserCallTo(error.more.callTo);
                                }
                            } else if (this.confirmationType === this.const.CONFIRM_TYPE_BOT_CALL) {
                                this.setBotCallTimeout(error.more.timeout);
                                this.setBotCallLength(error.more.length);
                            }
                            else if (this.confirmationType === this.const.CONFIRM_TYPE_BOT_SPEECH) {
                                this.setBotSpeechTimeout(error.more.timeout);
                                this.setBotSpeechLength(error.more.length);
                            }
                            break;
                        }
                        case 'ERROR_NEED_CAPTCHA': {
                            this.setCaptchaCode('');
                            this.setCaptchaId(error.more.captchaId)
                            this.setCaptchaSrc(error.more.captchaSrc)
                            this.setCaptchaLength(error.more.captchaLength)

                            break;
                        }
                        case 'ERROR_INVALID_SMS_CODE': {
                            this.setSmsCode('');
                            this.setSmsCodeError(error.msg);
                            break;
                        }
                        case 'SERVICE_ERROR_UNKNOWN':
                        case 'SERVICE_ERROR_RESPONSE': {
                            this.resetCaptcha();
                            this.showConfirm();
                            this.setError(error.msg);
                            break;
                        }
                        default: {
                            this.setError(error.msg);
                            break;
                        }
                    }
                },

                /**
                 * Запрос новой капчи
                 */
                refreshCaptcha() {
                    this.resetMessage();

                    this.captchaLoader = true;

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        method: 'refreshCaptcha',
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {

                            BX.Vue.event.$emit('BXmakerAuthuserphoneSimpleAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            if (r.response) {

                                this.captchaId = r.response.captchaId;
                                this.captchaSrc = r.response.captchaSrc;
                                this.captchaLength = r.response.captchaLength;
                                this.captchaCode = '';

                            } else {
                                this.parseError(r.error);
                            }

                            this.captchaLoader = false;
                        },
                        onfailure: (e) => {
                            this.captchaLoader = false;
                        }
                    });

                },

                /**
                 * СБрос состояния капчи
                 */
                resetCaptcha() {
                    this.captchaCode = false;
                    this.captchaId = false;
                    this.captchaSrc = false;
                    this.captchaLength = false;
                },

                /**
                 * СБрос состояния капчи
                 */
                hideCaptcha() {
                    this.captchaSrc = false;
                },

                //установка  кода с картиник
                setCaptchaCode(value) {
                    this.captchaCode = value;
                },
                setCaptchaId(value) {
                    this.captchaId = value;
                },
                setCaptchaSrc(value) {
                    this.captchaSrc = value;
                },
                setCaptchaLength(value) {
                    this.captchaLength = +value;
                },

                // Начало авторизации
                authByPhone() {
                    if (this.authByPhoneLoader) {
                        return false;
                    }
                    this.resetMessage();

                    this.setAuthByPhoneLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        method: 'authByPhone',
                        phone: this.phone,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {

                            BX.Vue.event.$emit('BXmakerAuthuserphoneSimpleAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {
                                this.afterAuthSuccessful(r.response);

                            } else {
                                this.parseError(r.error);
                                this.setAuthByPhoneLoader(false);
                            }


                        },
                        onfailure: (e) => {
                            this.setAuthByPhoneLoader(false);
                        }
                    });
                },

                //Запуск начала проверки
                startConfirm() {
                    switch (this.confirmationType) {
                        case this.const.CONFIRM_TYPE_SMS_CODE: {
                            this.startConfirmSmsCode();
                            break;
                        }
                        case this.const.CONFIRM_TYPE_USER_CALL: {
                            this.startConfirmUserCall();
                            break;
                        }
                        case this.const.CONFIRM_TYPE_BOT_CALL: {
                            this.startConfirmBotCall();
                            break;
                        }
                        case this.const.CONFIRM_TYPE_BOT_SPEECH: {
                            this.startConfirmBotSpeech();
                            break;
                        }
                    }
                },

                /**
                 * Начало проверки через код в смс
                 */
                startConfirmSmsCode() {
                    if (this.smsCodeStartLoader) {
                        return false;
                    }

                    this.resetMessage();
                    // this.hideCaptcha();

                    this.setSmsCodeStartLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        method: 'startConfirm',
                        type: this.const.CONFIRM_TYPE_SMS_CODE,
                        captchaId: this.captchaId,
                        captchaCode: this.captchaCode,
                        phone: this.phone,
                    });


                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {

                            BX.Vue.event.$emit('BXmakerAuthuserphoneSimpleAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {
                                this.setFormattedPhone(r.response.formattedPhone);
                                this.setSmsCodeLength(r.response.length);
                                this.setSmsCodeTimeout(r.response.timeout);

                                this.resetCaptcha();
                                this.showConfirm();

                            } else {
                                this.parseError(r.error);

                            }

                            this.setSmsCodeStartLoader(false);
                        },
                        onfailure: (e) => {
                            this.setSmsCodeStartLoader(false);
                        }
                    });
                },

                /**
                 * Начало проверки через звонок от пользователя
                 */
                startConfirmUserCall() {
                    if (this.userCallStartLoader) {
                        return false;
                    }
                    this.resetMessage();
                    // this.hideCaptcha()


                    this.setUserCallStartLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        method: 'startConfirm',
                        type: this.const.CONFIRM_TYPE_USER_CALL,
                        captchaId: this.captchaId,
                        captchaCode: this.captchaCode,
                        phone: this.phone,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {

                            BX.Vue.event.$emit('BXmakerAuthuserphoneSimpleAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setFormattedPhone(r.response.formattedPhone);

                                this.setUserCallTo(r.response.callTo);
                                this.setUserCallTimeout(r.response.timeout);

                                this.resetCaptcha()

                                this.showConfirm();

                            } else {
                                this.parseError(r.error);
                            }

                            this.setUserCallStartLoader(false);
                        },
                        onfailure: (e) => {
                            this.setUserCallStartLoader(false);
                        }
                    });
                },

                /**
                 * Начало подтверждения через звонок от бота
                 */
                startConfirmBotCall() {
                    if (this.botCallStartLoader) {
                        return false;
                    }
                    this.resetMessage();
                    // this.hideCaptcha();

                    this.setBotCallStartLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        method: 'startConfirm',
                        type: this.const.CONFIRM_TYPE_BOT_CALL,
                        phone: this.phone,
                        captchaId: this.captchaId,
                        captchaCode: this.captchaCode,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneSimpleAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setFormattedPhone(r.response.formattedPhone);
                                this.setBotCallLength(r.response.length);
                                this.setBotCallTimeout(r.response.timeout);

                                this.resetCaptcha()

                                this.showConfirm();

                            } else {
                                this.parseError(r.error);
                            }

                            this.setBotCallStartLoader(false);
                        },
                        onfailure: (e) => {
                            this.setBotCallStartLoader(false);
                        }
                    });
                },
                /**
                 * Начало подтверждения через звонок от бота
                 */
                startConfirmBotSpeech() {
                    if (this.botSpeechStartLoader) {
                        return false;
                    }
                    this.resetMessage();
                    // this.hideCaptcha();

                    this.setBotSpeechStartLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        method: 'startConfirm',
                        type: this.const.CONFIRM_TYPE_BOT_SPEECH,
                        phone: this.phone,
                        captchaId: this.captchaId,
                        captchaCode: this.captchaCode,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneSimpleAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setFormattedPhone(r.response.formattedPhone);
                                this.setBotSpeechLength(r.response.length);
                                this.setBotSpeechTimeout(r.response.timeout);

                                this.resetCaptcha()

                                this.showConfirm();

                            } else {
                                this.parseError(r.error);
                            }

                            this.setBotSpeechStartLoader(false);
                        },
                        onfailure: (e) => {
                            this.setBotSpeechStartLoader(false);
                        }
                    });
                },

                afterAuthSuccessful(data) {
                    if (data.redirect && this.isEnabledRedirect) {
                        location.href = data.redirect;
                    } else if (data.reload && this.isEnabledReload) {
                        location.reload();
                    }
                    else
                    {
                        this.setIsAuthorized(true);
                        this.setAuthByPhoneLoader(false);
                    }
                }

            },
            template: `<BXmakerAuthuserphoneSimple :key="data.rand" />`,
        });

        this.instance.mount('#' + this.rootId);

        return new Promise((resolve, reject) => resolve());
    }

}